import React, { useState } from 'react';
import { useNavigate, useLocation, Routes, Route } from 'react-router-dom';
import './Administration.css';
import AdministrationHome from './AdministrationHome';
import AdministrationTemplates from './templates/AdministrationTemplates';
import AdministrationPrompts from './prompts/AdministrationPrompts';
import AdministrationScripts from './scripts/AdministrationScripts';
import AdministrationLLMLogs from './logs/AdministrationLLMLogs';
import PromptSetEdit from './prompts/PromptSetEdit';

function Administration() {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(() => {
    // Determine active tab based on current path
    if (location.pathname.includes('/administration/templates')) return 'templates';
    if (location.pathname.includes('/administration/prompts')) return 'prompts';
    if (location.pathname.includes('/administration/scripts')) return 'scripts';
    if (location.pathname.includes('/administration/llm-logs')) return 'llm-logs';
    return 'home';
  });

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    navigate(`/administration/${tab === 'home' ? '' : tab}`);
  };

  const renderContent = () => {
    // Check if we're on a prompt set edit/create route
    if (location.pathname.includes('/administration/prompts/edit/') || 
        location.pathname.includes('/administration/prompts/create')) {
      return <PromptSetEdit />;
    }

    // Otherwise render based on active tab
    switch (activeTab) {
      case 'templates':
        return <AdministrationTemplates />;
      case 'prompts':
        return <AdministrationPrompts />;
      case 'scripts':
        return <AdministrationScripts />;
      case 'llm-logs':
        return <AdministrationLLMLogs />;
      default:
        return <AdministrationHome />;
    }
  };

  return (
    <div className="administration-container">
      <div className="administration-sidebar">
        <div className="sidebar-header">
          <h2>Administration</h2>
        </div>
        <nav className="sidebar-nav">
          <button
            className={`nav-item ${activeTab === 'home' ? 'active' : ''}`}
            onClick={() => handleTabClick('home')}
          >
            <i className="ti ti-home"></i>
            <span>Home</span>
          </button>
          <button
            className={`nav-item ${activeTab === 'templates' ? 'active' : ''}`}
            onClick={() => handleTabClick('templates')}
          >
            <i className="ti ti-file-text"></i>
            <span>Templates</span>
          </button>
          <button
            className={`nav-item ${activeTab === 'prompts' ? 'active' : ''}`}
            onClick={() => handleTabClick('prompts')}
          >
            <i className="ti ti-message-circle"></i>
            <span>Prompt Sets</span>
          </button>
          <button
            className={`nav-item ${activeTab === 'scripts' ? 'active' : ''}`}
            onClick={() => handleTabClick('scripts')}
          >
            <i className="ti ti-file-code"></i>
            <span>Prompt Scripts</span>
          </button>
          <button
            className={`nav-item ${activeTab === 'llm-logs' ? 'active' : ''}`}
            onClick={() => handleTabClick('llm-logs')}
          >
            <i className="ti ti-database"></i>
            <span>LLM Logs</span>
          </button>
        </nav>
      </div>
      <div className="administration-content">
        {renderContent()}
      </div>
    </div>
  );
}

export default Administration; 